import axios from "axios";
import store from "../store/index";
import { Message } from "view-design";
import global from "../global.js";
//设置全局axios默认值

// axios.defaults.timeout = 5000; //5000的超时验证
axios.defaults.withCredentials = true; //允许携带cookie
axios.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";

//创建一个axios实例
const instance = axios.create({
  baseURL: global.BASE_URL
});
instance.defaults.headers.post["Content-Type"] =
  "application/json;charset=UTF-8";

axios.interceptors.request.use = instance.interceptors.request.use;

//request拦截器
instance.interceptors.request.use(
  config => {
    config.url = timestamp(config.url);
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);
function timestamp(url) {
  var getTimestamp = new Date().getTime();
  if (url.indexOf("?") > -1) {
    url = url + "&timestamp=" + getTimestamp;
  } else {
    url = url + "?timestamp=" + getTimestamp;
  }
  return url;
}

//response拦截器
instance.interceptors.response.use(
  //除了200状态码
  response => {
    return response;
  },
  error => {
    switch (error.response.status) {
      case 401:
        //重置用户信息
        store.dispatch("commitUserMsg", {});
        store.dispatch("commitIsShow", true);
        Message.error("登录已失效，请重新登录。");
        break;
      case 400: //业务错误
        switch (Math.floor(error.response.data.code / 1000)) {
          case 2:
            Message.error(error.response.data.data);
            break;
          default:
            break;
        }
        break;
      default:
        Message.error(error.response.data.data);
        break;
    }
    return Promise.reject(error.response);
  }
);

// const defaultUrl = "/api";
const defaultUrl = "";

export default {
  /*
   * 获取图片验证码
   * */
  getCaptcha() {
    return instance.get(`${defaultUrl}/api/v1/auth/verify/captcha`);
  },
  /*
   * 获取短信验证码
   * */
  postVerificationCode(data) {
    return instance.post(
      `${defaultUrl}/api/v1/auth/verify/verificationCode`,
      data
    );
  },
  /*
   * 登录后获取短信验证码
   * */
  postVerificationCodeId(data) {
    return instance.post(
      `${defaultUrl}/api/v1/auth/verify/verificationCodeByUid`,
      data
    );
  },
  /*
   * 用户注册
   * */
  postUserRegister(data) {
    return instance.post(`${defaultUrl}/api/v1/auth/user/register`, data);
  },
  /*
   * 用户登录
   * */
  postUserLogin(data) {
    return instance.post(`${defaultUrl}/api/v1/auth/user/login`, data);
  },
  /*
   * 获取用户信息
   * */
  getUserMessage() {
    return instance.get(`${defaultUrl}/api/v1/auth/user/me`);
  },
  /*
   * 修改密码
   * */
  putResetPassword(data) {
    return instance.put(`${defaultUrl}/api/v1/auth/user/resetPassword`, data);
  },
  /*
   * 退出登录
   * */
  deleteLogout() {
    return instance.delete(`${defaultUrl}/api/v1/auth/user/logout`);
  },
  /*
   * 忘记密码
   * */
  putFindPasswordByPhone(data) {
    return instance.put(
      `${defaultUrl}/api/v1/auth/user/findPasswordByPhone`,
      data
    );
  },
  /*
   *账户是否已经注册
   * */
  postValidateAccount(data) {
    return instance.post(
      `${defaultUrl}/api/v1/auth/user/validateAccount`,
      data
    );
  },
  /*
   *获取公告栏信息
   * */
  postTitlePage(data) {
    return instance.post(`${defaultUrl}/api/v1/sys/article/titlePage`, data);
  },
  /*
   *获取单篇文章
   * */
  getArticle(articleId) {
    return instance.get(`${defaultUrl}/api/v1/sys/article/${articleId}`);
  },
  /*
   *获取帮助文档
   * */
  getHelpDocs() {
    return instance.get(`${defaultUrl}/api/v1/sys/article/5`);
  }
};
